function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#002A33;}\n\t.st2{clip-path:url(#SVGID_00000096052534891524685750000010908132229899256234_);}\n\t.st3{fill:#6CB9B2;}\n\t.st4{fill:#82C695;}\n\t.st5{fill:#6ABF8E;}\n\t.st6{fill:#62B189;}\n\t.st7{fill:#A5D3A5;}\n\t.st8{fill:#C2DEB2;}\n\t.st9{fill:#89C99B;}\n\t.st10{fill:#4DA17E;}\n\t.st11{fill:#127E5C;}\n\t.st12{fill:#CFE3B1;}\n\t.st13{fill-rule:evenodd;clip-rule:evenodd;fill:#DDB08F;}\n\t.st14{fill-rule:evenodd;clip-rule:evenodd;fill:#D0A387;}\n\t.st15{fill-rule:evenodd;clip-rule:evenodd;fill:#CBA389;}\n\t.st16{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000146461483196131745780000016954118318204370355_);}\n\t.st17{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000003815570533535247580000008431013511193014461_);}\n\t.st18{fill-rule:evenodd;clip-rule:evenodd;fill:#C5681D;}\n\t.st19{fill-rule:evenodd;clip-rule:evenodd;fill:#B0B0B0;}\n\t.st20{fill-rule:evenodd;clip-rule:evenodd;fill:#969696;}\n\t.st21{fill-rule:evenodd;clip-rule:evenodd;fill:#281704;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  className: "st0",
  cx: 139.9,
  cy: 139.9,
  r: 131.4
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M139.9,279.7C62.7,279.7,0,217,0,139.9S62.7,0,139.9,0s139.9,62.7,139.9,139.9S217,279.7,139.9,279.7z  M139.9,17C72.1,17,17,72.1,17,139.9s55.1,122.9,122.9,122.9s122.9-55.1,122.9-122.9S207.6,17,139.9,17z"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
  id: "SVGID_1_",
  cx: 140,
  cy: 139.8,
  rx: 123.1,
  ry: 122.6
}));

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: -22.6,
  y: -9.5,
  className: "st3",
  width: 319.4,
  height: 319.4
});

var _ref6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "58.7,75.1 -33.8,75.1 -33.8,192.9 197.6,192.9 197.6,157.4 197.6,75.1  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M58.7,75.1v10.8h115.4v0c0,6.6,6.7,9.7,11.9,8.6h0.1v62.8h11.5V75.1H58.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M186.1,171.2L186.1,171.2c-3.2,0-6.2,1.3-8.4,3.5s-3.5,5.4-3.5,8.6c0,0.5,0.1,1.1,0.1,1.6H-9.3v-2.8h-0.1 c0-0.4,0.1-0.7,0.1-1.1c0-6.4-5.4-11.8-11.8-11.8c-0.2,0-0.4,0-0.6,0v-72c0.2,0,0.4,0,0.6,0c6.3,0,11.5-5.1,11.7-11.4h68V75.1 h-92.5v117.8h231.4v-35.6h-11.5V171.2L186.1,171.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M182.9,97.7L182.9,97.7l0.1,65.2v5.9h-0.1c-3.1,0-6.1,1.2-8.3,3.4c-2.2,2.2-3.4,5.2-3.4,8.3 c0,0.5,0.1,1,0.1,1.5H-9.3v2.8h183.5c-0.1-0.5-0.1-1-0.1-1.6c0-3.2,1.3-6.3,3.5-8.6s5.2-3.5,8.4-3.5h0.1V94.6H186 c-5.1,1.1-11.9-2-11.9-8.6v0h-3v0C171.1,92.4,176.5,97.7,182.9,97.7L182.9,97.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M15.2,119.7c7.2,0.8,12.9,6.9,12.9,14.3s-5.6,13.5-12.9,14.3V163h35.2c-7.3-7.7-11.8-18.2-11.8-29.7 c0-23.9,19.4-43.2,43.2-43.2s43.2,19.4,43.2,43.2c0,11.5-4.5,21.9-11.8,29.7h37.9v-14.6c-0.4,0-0.7,0.1-1.1,0.1 c-7.9,0-14.4-6.4-14.4-14.4s6.4-14.4,14.4-14.4c0.4,0,0.8,0,1.1,0.1V85.9h-136V119.7L15.2,119.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M164.5,134c0,7.6-5.9,13.8-13.3,14.4V163h21.5c-0.1-0.3-0.2-0.6-0.2-0.9v-57.7c0-1.5,1.2-2.7,2.6-2.7 s2.6,1.2,2.6,2.7V162c0,0.3-0.1,0.6-0.2,0.9h5.4V97.7h-0.1c-6.4,0-11.8-5.3-11.8-11.8v0h-19.9v33.8 C158.6,120.2,164.5,126.5,164.5,134z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M171.2,182.1c-0.1-0.5-0.1-1-0.1-1.5c0-3.1,1.2-6.1,3.4-8.3c2.2-2.2,5.2-3.4,8.3-3.4h0.1V163h-5.4 c-0.4,1.1-1.3,1.8-2.4,1.8s-2.1-0.8-2.4-1.8h-59.3c-7.9,8.3-19,13.6-31.4,13.6s-23.5-5.2-31.4-13.6H15.2v-14.6 c-0.5,0.1-1,0.1-1.6,0.1c-7.9,0-14.4-6.4-14.4-14.4s6.4-14.4,14.4-14.4c0.5,0,1,0,1.6,0.1V85.9H-9.3 c-0.2,6.2-5.5,11.4-11.7,11.4c-0.2,0-0.4,0-0.6,0v72.1c0.2,0,0.4,0,0.6,0c6.4,0,11.8,5.4,11.8,11.8c0,0.4,0,0.7-0.1,1.1 L171.2,182.1L171.2,182.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M88.4,152.3c3.3-1.8,5.8-4.9,5.3-8.9c-0.2-1.8-1-3.2-2.2-4.2c-1-0.4-2.1-0.7-3.2-0.9 C88.4,142.9,88.4,147.6,88.4,152.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M75,117.6c-0.2,0.2-0.4,0.4-0.6,0.7c-0.1,0.2-0.4,0.5-0.4,0.6c-0.2,0.3-0.4,0.7-0.6,1l0,0 c0,0.1,0,0.1-0.1,0.2c-0.1,0.2-0.1,0.4-0.2,0.6c0,0.2,0,0.5,0,0.6c0,0.1,0,0.2,0,0.2c0,0.1,0.1,0.2,0.1,0.3 c0.1,0.2,0.3,0.6,0.3,0.7c0.1,0.1,0.1,0.2,0.2,0.3c0.1,0.1,0.5,0.6,0.6,0.6c0.8,0.7,0.6,0.7,1.8,1.3c0.5,0.3,0.9,0.5,1.4,0.7 c-0.1-3.2-0.2-6.3-0.2-9.5c-0.1,0.1-0.2,0.1-0.4,0.2C75.5,117,76.1,116.5,75,117.6L75,117.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M81.9,176.5c12.4,0,23.5-5.2,31.4-13.6c7.3-7.7,11.8-18.2,11.8-29.7c0-23.9-19.4-43.2-43.2-43.2 s-43.2,19.4-43.2,43.2c0,11.5,4.5,21.9,11.8,29.7C58.3,171.3,69.5,176.5,81.9,176.5L81.9,176.5z M77.8,152.7 c-0.1-5.5-0.1-11-0.1-16.6c-3-0.8-5.9-1.9-8.5-3.8c-1.1-0.5-2.1-1.1-3.1-1.9c-7.4-5.6-6.6-15.2,0.3-20.9 c3.2-2.6,6.8-4.1,10.7-4.6c0-2-0.1-4-0.1-6.1c0-2.6,2.7-3.5,4.5-2.7c2.4-1.3,6.2-0.2,6.2,3.4c0,1.7,0,3.3,0,5 c3.4,0.6,6.7,1.8,9.8,3.8c5.5,3.5,0.4,12.2-5.1,8.7c-1.6-1-2.9-1.7-4.5-2.2c0.1,4.4,0.2,8.8,0.3,13.2c3,0.6,5.9,1.2,8.7,2.5 c13.4,6.2,11.1,24.9-1.4,30.8c-2.2,1-4.4,1.7-6.8,2.1c0,1.2,0.1,2.3,0.2,3.5c0.2,4.3-5.3,5-7.3,2.2c-1.6,0.1-3.2-0.9-3.3-3 c-0.1-1-0.1-2-0.1-3.1c-1.4-0.3-2.7-0.7-4-1.2c-1.4-0.6-2.8-1.3-4.1-2.2c-5.4-2.2-9.4-6.5-9.3-13.1c0-3,2.8-4.1,5-3.6 c3-1.5,7.5-0.1,7.4,4.3c0,0,0.2,1.4,0.1,1.1C73.8,150.6,75.6,151.9,77.8,152.7L77.8,152.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M-0.7,134c0,7.9,6.4,14.4,14.4,14.4c0.5,0,1,0,1.6-0.1c7.2-0.8,12.9-6.9,12.9-14.3s-5.6-13.5-12.9-14.3 c-0.5-0.1-1-0.1-1.6-0.1C5.8,119.6-0.7,126.1-0.7,134L-0.7,134z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M164.5,134c0-7.6-5.9-13.8-13.3-14.3c-0.4,0-0.7-0.1-1.1-0.1c-7.9,0-14.4,6.4-14.4,14.4 s6.4,14.4,14.4,14.4c0.4,0,0.8,0,1.1-0.1C158.6,147.8,164.5,141.6,164.5,134L164.5,134z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M69.2,132.3c2.6,1.9,5.4,3,8.5,3.8c0-0.4,0-0.8,0-1.2C74.7,134.4,71.8,133.6,69.2,132.3L69.2,132.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M73.1,147.5c0.1-4.4-4.4-5.8-7.4-4.3c1.5,0.4,2.7,1.6,2.7,3.6c-0.1,4.6,5,6.7,9.4,7.3c0-0.4,0-0.9,0-1.4 c-2.2-0.8-4-2.1-4.6-4.1C73.3,148.9,73.1,147.5,73.1,147.5L73.1,147.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M88.4,152.3c-0.1-4.7-0.1-9.3-0.1-14c1.1,0.2,2.2,0.5,3.2,0.9c-2-1.8-5-2.6-7.8-3.1 c0.1,6,0.1,11.9,0.2,17.9C85.5,153.7,87,153.1,88.4,152.3L88.4,152.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M83.1,98.8c0,2,0,4.1,0.1,6.1c3.6,0.5,7,1.8,10.1,3.7c4.2,2.7,0.3,9.3-3.9,6.6c-1.9-1.2-4-2.1-6.1-2.6 c0.1,5.2,0.2,10.4,0.3,15.6c2.4,0.4,4.8,0.9,7.1,1.8c5.8,2.3,10.5,6.7,10.7,13.4c0.2,6.6-3.8,13-9.7,15.9 c-2.2,1.1-4.8,1.8-7.6,2.2c0.1,1.6,0.1,3.2,0.2,4.7c0.1,1.9-1.3,2.9-2.8,3c2.1,2.8,7.6,2.1,7.3-2.2c-0.1-1.2-0.1-2.3-0.2-3.5 c2.3-0.4,4.6-1.1,6.8-2.1c12.5-5.9,14.8-24.6,1.4-30.8c-2.8-1.3-5.8-2-8.7-2.5c-0.1-4.4-0.2-8.8-0.3-13.2c1.7,0.5,3,1.2,4.5,2.2 c5.5,3.5,10.6-5.2,5.1-8.7c-3.1-2-6.4-3.2-9.8-3.8c0-1.7,0-3.3,0-5c0-3.6-3.8-4.7-6.2-3.4C82.4,96.7,83.1,97.5,83.1,98.8 L83.1,98.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M76.1,124.8c-1.2-0.7-1.1-0.6-1.8-1.3c-0.1-0.1-0.4-0.5-0.6-0.6c-0.1-0.1-0.1-0.2-0.2-0.3 c0-0.1-0.2-0.5-0.3-0.7c0-0.1-0.1-0.2-0.1-0.3c0,0,0-0.1,0-0.2c0-0.1,0-0.4,0-0.6c0.1-0.2,0.1-0.4,0.2-0.6c0-0.1,0-0.2,0.1-0.2 l0,0c0.2-0.4,0.4-0.7,0.6-1.1c0.1-0.1,0.3-0.4,0.4-0.6c0.2-0.2,0.4-0.5,0.6-0.7c1.1-1.1,0.5-0.6,1.8-1.4 c0.1-0.1,0.2-0.2,0.4-0.2c0-1.1,0-2.2-0.1-3.3c-0.4,0.1-0.8,0.2-1.2,0.3c-3,0.9-6.5,3.2-7.3,6.1c-0.3,1.2-0.4,2.3,0.3,3.4 c1,1.6,2.7,2.6,4.3,3.3c1.3,0.6,2.8,1,4.2,1.4c0-0.6,0-1.1,0-1.7C76.9,125.3,76.5,125,76.1,124.8L76.1,124.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M69.9,159.8c1.3,0.9,2.7,1.6,4.1,2.2c1.3,0.5,2.7,0.9,4,1.2c0-0.5,0-1-0.1-1.6 C75.2,161.4,72.4,160.8,69.9,159.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M68.4,146.8c0-2-1.2-3.2-2.7-3.6c-2.2-0.6-5,0.6-5,3.6c-0.1,6.6,3.9,10.8,9.3,13.1c2.5,1,5.2,1.6,8,1.9 c0,0.5,0,1,0.1,1.6c0,1,0.1,2,0.1,3.1c0.1,2,1.8,3,3.3,3c1.5-0.1,2.9-1,2.8-3c-0.1-1.6-0.2-3.2-0.2-4.7c2.8-0.3,5.4-1.1,7.6-2.2 c5.9-3,9.8-9.4,9.7-15.9c-0.2-6.6-4.8-11.1-10.7-13.4c-2.3-0.9-4.7-1.4-7.1-1.8c-0.1-5.2-0.2-10.4-0.3-15.6 c2.2,0.5,4.2,1.4,6.1,2.6c4.2,2.7,8-4,3.9-6.6c-3.1-2-6.6-3.3-10.1-3.7c0-2-0.1-4.1-0.1-6.1c0-1.3-0.7-2.2-1.6-2.7 c-1.8-0.9-4.5,0-4.5,2.7c0,2,0,4,0.1,6.1c-3.8,0.5-7.5,2-10.7,4.6c-6.9,5.7-7.6,15.3-0.3,20.9c1,0.8,2,1.4,3.1,1.9 c2.6,1.3,5.5,2.1,8.4,2.6c0,0.4,0,0.8,0,1.2c0.1,5.5,0.1,11.1,0.1,16.6c0,0.4,0,0.9,0,1.4C73.3,153.4,68.3,151.4,68.4,146.8 L68.4,146.8z M91.6,139.2c1.2,1,2,2.4,2.2,4.2c0.5,4-2,7-5.3,8.9c-1.4,0.8-3,1.4-4.5,1.7c-0.1-6-0.1-11.9-0.2-17.9 C86.6,136.6,89.6,137.4,91.6,139.2L91.6,139.2z M73.3,125.8c-1.7-0.8-3.3-1.8-4.3-3.3c-0.7-1.2-0.7-2.2-0.3-3.4 c0.8-2.9,4.3-5.2,7.3-6.1c0.4-0.1,0.8-0.2,1.2-0.3c0,1.1,0,2.2,0.1,3.3c0.1,3.2,0.1,6.3,0.2,9.5c0,0.6,0,1.1,0,1.7 C76.1,126.8,74.7,126.4,73.3,125.8L73.3,125.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M175.1,164.8c1.1,0,2.1-0.8,2.4-1.8c0.1-0.3,0.2-0.6,0.2-0.9v-57.7c0-1.5-1.2-2.7-2.6-2.7s-2.6,1.2-2.6,2.7 v57.7c0,0.3,0.1,0.6,0.2,0.9C173,164,174,164.8,175.1,164.8z"
}));

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "st13",
  d: "M224.7,68.6c-0.8-1.3-1.8-2.4-4.4-2.6c-17,1.3-41.5,3.5-62.4,5.6c-7.9,0.2-16.3,0.4-24.9,1l-3.3,0.3 c-0.4,0.2-0.7,0.6-0.9,1.2c0.2,18.7,3.4,36.8,20.8,59.7c0.6,0.6,1,0.8,2.5-0.3c12-7.5,23.7-15.3,40.5-16.4 c-0.9,2-2.1,3.8-0.6,6.7c9.7,28.1,19.9,56.3,30.5,84.8c15.9,40.5,36,85.1,29.9,116.5c-0.2,4.5-0.4,9,3.6,12.2 c3.3,3,7.8,6.5,15.2,11c5-1,15.4-3.5,21.5-6.5c1.2-1.7,1.5-3.8,0.9-6.4c-5.8-15.8-11.7-31.1-17-56.6 c-4.9-16.2-13.7-40-27.1-70.1c-12.5-28.6-21.8-58-19.2-90.4c0.8-0.4-1.2-3.6-2.9-6.4l1.6,0.1c1.8-1.6,3.7-3.3,5.6-5.6 C232.1,95,229.9,84.3,224.7,68.6L224.7,68.6z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M252.5,325c6.1-31.4-14-76-29.9-116.5c-8.1-21.7-15.9-43.2-23.5-64.6c9.8,24.3,21.6,48.6,33.8,72.9 c33.7,62.7,29.9,89.1,25.6,115.2c-0.9,1.5-2,2.7-3.4,3.4l-0.9,0C252.2,332.4,252.3,328.7,252.5,325L252.5,325z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M250.4,215.9c-23.1-50.2-25.4-77.2-24.1-98.4l3.9-1c0.4,0.9,0.5,1.5,0.2,1.7c-2.6,32.3,6.7,61.8,19.2,90.4 c13.4,30.2,22.2,53.9,27.1,70.1c0,0.2,0.1,0.4,0.1,0.6C270.5,260.4,261.8,239.4,250.4,215.9L250.4,215.9z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "st18",
  d: "M234.5,106.6c-1.9,2.1-3.6,3.8-5.4,5.3l-1.6-0.1c0,0,0.1,0.1,0.1,0.1l-0.4-0.4c-1.6-1.9-3.4-3.8-5.5-3.1 c-8.7,1.8-23.6,3.5-29,8.3l-0.4,0.3c-16.6,1.2-28.3,9-40.2,16.4h0l-0.2-0.1C181.9,112.3,208.2,109.4,234.5,106.6L234.5,106.6z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "st19",
  d: "M128.9,74c0.1-0.6,0.4-1,0.9-1.2l3.3-0.3c8.6-0.6,17-0.8,24.9-1c0,0,0.1,0,0.1,0c5.4,16.5,11,33,14.8,49.6 l0.1,0.7c-7.4,3.2-14.1,7.4-20.7,11.6c-1.5,1.1-1.9,0.9-2.5,0.3C132.3,110.8,129,92.7,128.9,74L128.9,74z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "st18",
  d: "M234.5,106.6c-1.9,2.1-3.6,3.8-5.4,5.3l-1.6-0.1c0,0,0.1,0.1,0.1,0.1l-0.4-0.4c-1.6-1.9-3.4-3.8-5.5-3.1 c-8.7,1.8-23.6,3.5-29,8.3l-0.4,0.3c-16.6,1.2-28.3,9-40.2,16.4h0l-0.2-0.1C181.9,112.3,208.2,109.4,234.5,106.6L234.5,106.6z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "st20",
  d: "M128.9,74c0.1-0.6,0.4-1,0.9-1.2l3.1-0.3c-0.5,11.2,5.7,42.7,21,59.5l0.1,0.2c-0.6,0.4-1.2,0.7-1.8,1.1 c-1.5,1.1-1.9,0.9-2.5,0.3C132.3,110.8,129.1,92.7,128.9,74L128.9,74z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "st21",
  d: "M172.6,121.2l0.2,0.7c-7.4,3.2-14,7.4-20.6,11.6h0l-0.2-0.1C159.1,128.4,165.9,124.4,172.6,121.2z"
});

function SvgQ5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 279.7 279.7",
    style: {
      enableBackground: "new 0 0 279.7 279.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", null, _ref3, /*#__PURE__*/React.createElement("g", null, _ref4, /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000152946267366318272030000002069214578065037759_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000152946267366318272030000002069214578065037759_)"
    }
  }, _ref5, _ref6, /*#__PURE__*/React.createElement("g", null, _ref7, _ref8, _ref9, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000014625448033094197420000005614031637333988287_",
    gradientUnits: "userSpaceOnUse",
    x1: 359.4171,
    y1: 688.7059,
    x2: 344.4471,
    y2: 659.7759,
    gradientTransform: "matrix(0.6056 0.7958 0.7958 -0.6056 -521.5503 235.7449)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#65452D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AB8060"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000014625448033094197420000005614031637333988287_)"
    },
    d: " M192.1,123.7c-1.4-2.9-0.2-4.7,0.6-6.7c-1.6,0.1-3.3,0.3-4.8,0.5l3.6-7l20-10.9l11.2,2.7l7.2,7.8l0.5,0.6 c-0.4,0.4-0.9,0.8-1.3,1.2l-1.6-0.1c1.1,1.9,2.4,3.9,2.9,5.2c-10.8,2.6-21.6,5.9-32.2,4.6c-2.9-0.6-5.7-1-5.9,2.8l0,0 C192.2,124.1,192.2,123.9,192.1,123.7L192.1,123.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132088026247508346500000016147803522811324041_",
    gradientUnits: "userSpaceOnUse",
    x1: 333.3602,
    y1: 696.732,
    x2: 328.9302,
    y2: 686.1819,
    gradientTransform: "matrix(0.6056 0.7958 0.7958 -0.6056 -521.5503 235.7449)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C4691E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FC8023"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000132088026247508346500000016147803522811324041_)"
    },
    d: " M128.9,74c0.1-0.6,0.4-1,0.9-1.2l3.3-0.3c8.6-0.6,17-0.8,24.9-1c20.9-2,45.4-4.3,62.4-5.6c2.6,0.2,3.6,1.3,4.4,2.6 c5.2,15.7,7.5,26.4,10.1,37.7c-1.9,2.2-3.8,4-5.6,5.6l-1.6-0.1c0,0,0.1,0.1,0.1,0.1l-0.4-0.4c-1.6-1.9-3.4-3.8-5.5-3.1 c-8.7,1.8-23.6,3.5-29,8.3l-0.4,0.3c-16.6,1.2-28.3,9-40.2,16.4c-1.5,1.1-1.9,0.9-2.5,0.3C132.3,110.8,129.1,92.7,128.9,74 L128.9,74z"
  }), _ref10, _ref11, _ref12, _ref13, _ref14)))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQ5);
export default __webpack_public_path__ + "static/media/q5.82af0ea09be0372ff4b5557da0b522b1.svg";
export { ForwardRef as ReactComponent };